import { gql } from '@apollo/client';

const CREATE_ACCESS_PAGE_EVENT = gql`
  mutation createAccessPageEvent($data: AccessPageEventCreateInput!) {
    createAccessPageEvent(data: $data)
  }
`;

export default CREATE_ACCESS_PAGE_EVENT;
